export const phone =
  /^1?[\s-]?(?:\([2-9]\d{2}\)[\s-]?|[2-9]\d{2}(?:-?|\s?))[2-9]\d{2}[\s-]?\d{4}$/;
export const httpUrl = /^https?:\/\//;
export const localUrl = /^\//;
